<div class="mwp-modal">
    <div class="header w-100 d-flex justify-content-center">
        <mwp-text-translate text="UPDATE MFA" jsonKey="updateMFATitle" />
    </div>
    @if (verifyCodePass) {
        <div class="message-container green-fill text-center mb-2">
            MFA Updated!
        </div>
    }
    @if (mfaUpdateStepInstructions) {
        <div class="info-box m-3 mt-0 d-flex justify-content-center text-center">
            {{mfaUpdateStepInstructions}}
        </div>
    }
    
    <div class="body">
        @switch (mode) {
            @case (authenticatorMode.Selection) {
                <form [formGroup]="selectionModeForm" autocomplete="off">
                    <mwp-radio-button [form]="selectionModeForm" [displayInline]="false" nameForControl="verificationType" [data]="authenticatorTypes" keyText="text" keyValue="value" [autoTranslate]="false" />
                </form>
            }

            @case (authenticatorMode.Configuration){
                @if (configPhoneNumber) {
                    <form [formGroup]="configForm" autocomplete="off">
                        <mwp-input [form]="configForm" labelName="Phone Number" nameForControl="phoneNumber" [maskType]="maskType.phone" />
                    </form>
                }
                @if (configQR) {
                    <div class="d-flex justify-content-center mb-3">
                        <img [src]="selectedAuthenticatorQR.qrCodeUrl" style="width: 180px; height: 180px; image-rendering: pixelated;" />
                    </div>
                    <div class="message-instructions text-center mb-3">
                        <mwp-text-translate text="If you are unable to scan the code into your authenticator app, copy the code below instead." jsonKey="mfaQRManualEntryCode" />
                    </div>
                    <div>
                        <div class="text-center fw-bold px-3">
                            {{selectedAuthenticatorQR.manualEntryKey}}
                        </div>
                        <div class="d-flex justify-content-center">
                            <div class="d-inline-flex selectable-div" [cdkCopyToClipboard]="selectedAuthenticatorQR.manualEntryKey">
                            <mwp-text-translate text="Copy" jsonKey="copy" />
                            <mwp-svg-icon [SvgMatType]="svgType.Copy" [SvgColor]="svgColor.stdIcon" />
                            </div>
                        </div>
                    </div>
                }
            }

            @case (authenticatorMode.Verification) {
                <form [formGroup]="verifyForm" autocomplete="off">
                    <div class="fw-bold d-flex justify-content-center">
                        <div class="message-instructions mb-3">
                            @if (verifyMessageKey) {
                                <mwp-text-translate [text]="verifyMessage" [jsonKey]="verifyMessageKey" />
                            }
                            <mwp-text-translate text="Please input the code provided to log in." jsonKey="mfaVerify" />
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <mwp-verify-code [form]="verifyForm" nameForRadioControl="verifyCode" [useFixedWidth]="true" />
                    </div>
                    @if (verifyCodeFailed) {
                        <div class="message-container red-fill text-center mt-2">
                            Code Failed!
                        </div>
                    }
                </form>
            }
        }
    </div>
    <div class="footer">
        @switch (mode) {
            @case (authenticatorMode.Selection) {
                <div class="d-flex justify-content-center w-100 mb-3">
                    <button class="mwp-button mt-3 w-100" [disabled]="selectionModeForm.invalid" (click)="setSelection()">
                    <mwp-text-translate text="Continue" jsonKey="continue" />
                    </button>
                </div>
            }

            @case (authenticatorMode.Configuration){
                @if (configPhoneNumber) {
                    <div class="d-flex justify-content-center w-100 mb-3">
                        <button class="mwp-button w-100" [disabled]="configForm.invalid" (click)="setPhoneAndSendCode()">
                            <mwp-text-translate text="Continue" jsonKey="continue" />
                        </button>
                    </div>
                }
                @if (configQR) {
                    <div class="d-flex justify-content-center w-100 mb-3">
                        <button class="mwp-button w-100" (click)="setQRAndSendCode()">
                            <mwp-text-translate text="Continue" jsonKey="continue" />
                        </button> 
                    </div>
                }
                <div class="d-flex justify-content-center w-100 mb-3">
                    <button class="mwp-button-secondary w-100" (click)="resetConfiugration()">
                        <mwp-text-translate text="Return" jsonKey="return" />
                    </button>
                </div>
            }

            @case (authenticatorMode.Verification) {
                <div class="d-flex justify-content-center">
                    <button class="mwp-button mb-3 w-100" [disabled]="verifyForm.invalid" (click)="verifyCode()">
                        <mwp-text-translate text="Verify Code" jsonKey="verifyCode" />
                    </button>
                </div>
                @if (this.selectedAuthenticatorType.toString() != 'Q') {
                    <div class="d-flex justify-content-center">
                        <button class="mwp-button-secondary w-100 mb-3" (click)="resendCode()" [disabled]="!buttonEnabled">
                            {{getResendButtonText()}}
                        </button>
                    </div>
                }
            }
        }
        <button class="mwp-button-secondary w-100" (click)="close()">
            <mwp-text-translate text="CANCEL" jsonKey="cancel" />
        </button>
    </div>
</div>